export function OutlineRefreshIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9706 13.4996C19.9706 17.6431 16.6161 20.9992 12.4853 20.9992C8.35448 20.9992 5 17.6383 5 13.4996C5 9.3609 8.35448 6 12.4853 6H16.4771"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4822 3L16.4773 6.0008L13.4822 9.0016"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
